import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ConfigurationCompanyProductModel } from 'src/app/models/Configurations/ConfigurationCompanyProductModel';
import { ProductSalesResponse } from 'src/app/models/Sales/ProductSalesResponse';
import { SaleCanceledResponse } from 'src/app/models/Sales/SaleCanceledResponse';
import { SalesResumeTable } from 'src/app/models/Sales/SalesResumeTable.model';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { SalesService } from 'src/app/services/sales/sales.service';

interface DialogData {
    saleId: number;
    saleProducts?: MatTableDataSource<ProductSalesResponse>;
    sale?: SalesResumeTable;
    isCanceled: boolean;
    saleCanceled?: MatTableDataSource<SaleCanceledResponse>;
}

@Component({
    selector: 'app-dialog-sale-details',
    templateUrl: './dialog-sale-details.component.html',
    styleUrls: ['./dialog-sale-details.component.scss']
})
export class DialogSaleDetailsComponent implements OnInit {

    @ViewChild('outerSort', { static: true }) sort!: MatSort;

    configProduct: ConfigurationCompanyProductModel[] = []
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogData,
        private configService: ConfigurationService,
        private salesService: SalesService)
    {}

    async ngOnInit(): Promise<void> {
        if(!this.data.saleProducts) {
            this.data.saleProducts = new MatTableDataSource(await this.salesService.getSalesProduct([this.data.saleId]));
            this.data.saleProducts.sort = this.sort;
        }
        if(!this.data.sale) {
            this.data.sale = await this.salesService.getSaleById(this.data.saleId);
        }
        if (this.data.isCanceled && !this.data.saleCanceled) {
            this.data.saleCanceled = new MatTableDataSource(await this.salesService.getSaleCanceled(this.data.saleId));
        }
    }
    readonly displayedColumns: string[] = [
        'productCode',
        'name',
        'unitPrice',
        'quantity',
        'subtotal',
        'discount',
        'total'
    ];
    readonly displayedColumnsCanceled: string[] = [
        'fullName',
        'cancelDate',
        'uuid',
        'cancelReason'
    ];

    formatNumberByCountry(value: number): string {
        return this.configService.formatNumberByCountry(value);
    }

    formatDateByCountry(value: Date): string {
        return this.configService.formatDateWithHourLocaleByCountry(value);
    }

}
